import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { JobService } from '../../services/jobs/job.service'
import { JobComponent } from '../../jobs/job/job.component'
import { LearnersComponent } from '../../learners/learners.component'
import { SingleClientComponent } from '../../clients/single-client/single-client.component'
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs';
import { AddLocationComponent } from '../single-client/add-location/add-location.component';
import { LocationStrategy, Location } from '@angular/common';
import { LabourJobService } from '../../labour-job/labour-job.service';


@Component({
  selector: 'app-client-dashboard',
  templateUrl: './client-dashboard.component.html',
  styleUrls: ['./client-dashboard.component.scss']
})
export class ClientDashboardComponent implements OnInit {
  jobs = [];
  jobToPass;
  currentUser;
  user;
  clientName = '';
  selectedJob;
  clientId;
  private isSelected: string;
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  noJobsMsg: string;
  displayNoJobMsg: boolean = false;
  jobId: any = "123";
  location: any;
  currentJobTabIndex: any;
  currentLocation: any;
  queryParamsObj = {};
  percent: any;
  noDataMsg = {
    title: "No Jobs!",
    data: "You have not assigned any job"
  }
  mpJobSelected
  trainer: boolean = false
  loading: boolean;
  // @Input('location') location;


  constructor(
    public _jobService: JobService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private locationStrategy: LocationStrategy,
    private _location: Location,
    public _labourjobService: LabourJobService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }
  @ViewChild(JobComponent, { static: true }) jobComp: JobComponent;
  @ViewChild(LearnersComponent, { static: false }) learnerComp: LearnersComponent;
  // @ViewChild(SingleClientComponent, { static: false }) singleClient: JobComponent;

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.clientId = params.id;

      console.log('Client Id:::::::::::::', this.clientId, params.jobId);
      this.getJobsByClientId()
      this.getLabourjobByClient()

      console.log("jobs data trainer", this.jobs, this.selectedJob, this.trainer)
    });
    this.activatedRoute.queryParams.subscribe(qparams => {
      this.location = qparams.location
      if (qparams.job) {
        console.log("qparams.job", qparams.job)
        this.jobId = qparams.job
        // this.getCurrentJob()
        // this.getJobsByClientId();
      }
      if (qparams.location) {
        console.log("LOCATION", this.location);
        let data = { _id: this.location }
        this.getJobs(data)
      }

    })
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.clientName = this.currentUser.name;
    console.log("Jobs data", this.jobs, this.trainer)

    console.log('location in client-dashboard==>>', location);

    // this.getJobs();
  }
  setColor(value, i) {
    this.isSelected = value;
  }

  jobChanged(job) {
    console.log("JOB CHANGED DATA", job)

    this.selectedJob = job
    // this.trainer = job.jobType ? true : false
    console.log("TRAINER JOB VALUE", this.trainer)
    // if (job && job.jobType == 'trainer') {
    //   console.log("JOB CHANGED IN CLIENT DASHBOARD!!", job);

    //   this.mpJobSelected = ''
    //   this.selectedJob = job
    //   if (this.jobComp) {
    //     this.jobComp.job = job;
    //     this.jobComp.jobIdFromClient = job._id;
    //     this.jobComp.completionPercentage(job)
    //     this.jobComp.jobChangedByClient(job);
    //   }

    //   this.queryParamsObj['job'] = job._id;
    //   this.changeQuery();
    // } else {
    //   console.log("this is for mp jobs");
    //   this.mpJobSelected = job
    //   this.selectedJob = ''
    // }
  }
  percentForBadge(event) {
    console.log("PERCENT IN CLIENT DASHBOARD RECIEVED", event)
    this.percent = event.percent
  }
  getCurrentJob() {
    console.log("getCurrentJob");
    this._jobService.getJobById(this.jobId).subscribe(res => {
      console.log("response job", res)
      this.jobChanged(res)
    })
  }





  changeQuery() {
    // this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: this.queryParamsObj, queryParamsHandling: 'merge' });
    this._location.go(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        { relativeTo: this.activatedRoute, queryParams: this.queryParamsObj }).toString()
    );
  }

  displayJobs(jobs) {
    console.group("List of all jobs to pasas----------", jobs);
    let displayJobs = jobs

    if (this.jobId != "123") {
      console.log("in if")
      // let index = 0
      let tempId = this.jobId
      let index = _.findIndex(jobs, function (o) {
        console.log("in find Index", o._id, tempId)
        return o._id == tempId
      })
      if (index > -1) {
        console.log("match found at", index)
        this.selectedJob = jobs[index]
        this.trainer = this.selectedJob.jobType ? true : false
        let firstJob = jobs[index]
        console.log("FIRST JOB", firstJob);
        this.jobComp.job = firstJob;
        if (firstJob && firstJob._id) {
          this.jobComp.jobIdFromClient = firstJob._id;
          this.jobComp.completionPercentage(firstJob)
        }
        // this.jobComp.job = jobs[0];
        this.jobToPass = jobs[index];
        console.log("this.jobToPass", this.jobToPass);
        console.log("this.selectedJob", this.selectedJob);
      }
    }
    else {
      console.log("in else", jobs)
      let firstJob = jobs[0]
      if (firstJob) {
        if ((firstJob && firstJob._id) && (firstJob && firstJob.jobType == 'trainer')) {
          this.selectedJob = jobs[0]
          this.trainer = this.selectedJob.jobType ? true : false
          console.log("FIRST JOB FOR CLIENT DASHBOARD", firstJob, this.selectedJob, this.displayNoJobMsg);
          // this.jobComp.job = firstJob;
          // this.jobComp.jobIdFromClient = firstJob._id;
          // this.jobComp.completionPercentage(firstJob)
          console.log("call for trainer job", this.selectedJob);
        } else {
          // this.mpJobSelected = jobs[0]
          // console.log("call for mp jobs", this.mpJobSelected);
          console.log("Call for labour jobs: ", this.selectedJob)
        }
        // this.jobComp.job = jobs[0];
        this.jobToPass = jobs[0];
        console.log("this.jobToPass", this.jobToPass);
        console.log("this.selectedJob", this.selectedJob);
        console.groupEnd()
      }
    }
  }
  openFileDetails(data) {
    let event = data.event
    this.openFilesSideNav.emit({ event })
  }

  locationEvent(event) {
    console.log("event in client-dashboard", event);
    this.currentLocation = event._id
    this.displayNoJobMsg = false
    this.queryParamsObj['location'] = event._id;
    this.queryParamsObj['job'] = null;
    // this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: this.queryParamsObj, queryParamsHandling: 'merge', replaceUrl: true });
    // this.changeQuery();
    this.getJobs(event)
  }
  jobTab(event) {
    this.currentJobTabIndex = event
    console.log("this.currentJobTabIndex", this.currentJobTabIndex, event)
    this.queryParamsObj['currentTab'] = event.index;
    this.changeQuery();
  }
  locationModal() {
    this.openDialog(AddLocationComponent).subscribe(loc => {
      console.log("loc", loc);

    })
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data, width: '1000px', height: '967px' });

    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getJobs(event) {
    this._jobService.getJobUsingLocationId(event._id).subscribe(jobs => {
      console.log("Job recieved::::::::::::::", jobs);
      this.jobs = jobs;
      if (this.jobs.length == 0) {
        this.noJobsMsg = "No Jobs Added Yet!"
        this.displayNoJobMsg = true
      }
      else {
        console.log("call this else part which is not importanat");

        let displayJobs = this.jobs
        let newJobArray = []
        displayJobs.forEach((singleJob) => {
          console.log("single job value", singleJob);
          if (singleJob && singleJob.isArchive == false) {
            newJobArray.push(singleJob)
          }
        })
        if (newJobArray && newJobArray.length) {
          this.jobs = newJobArray
          this.displayJobs(this.jobs)
        } else {
          this.noJobsMsg = "No Jobs Added Yet!"
          this.displayNoJobMsg = true
        }
      }
    })
  }

  getLabourjobByClient() {
    this.loading = true

    this._labourjobService.getLabourjoblistbyClient(this.clientId).subscribe((jobList) => {
      console.log("Job recieved::::::::::::::", jobList);
      // this.jobs = jobList.displayJobs
      if (jobList && jobList.displayJobs && jobList.displayJobs.length) {
        this.jobs = this.jobs.concat(jobList.displayJobs)
        console.log("Jobs data labour", this.jobs, jobList.displayJobs);
        this.selectedJob = this.jobs[0]
        this.trainer = this.selectedJob && this.selectedJob.jobType ? true : false
        console.log("SELECTED JOB DATA", this.selectedJob)
        this.loading = false
        if (this.jobs && !this.jobs.length) {
          this.noJobsMsg = "No Jobs Added Yet!"
          this.displayNoJobMsg = true
        }
      }
    }, error => {
      console.log("ERROR WHILE GET JOBS", error);

    })


  }


  getJobsByClientId() {
    console.log("FUNCTION CALLED IN CLIENT DASHBOARD!!!");
    this._jobService.getJobByClientId(this.clientId).subscribe(jobs => {
      console.log("Job recieved::::::::::::::", jobs);
      let newArray = []
      if (jobs && jobs.mpJobs) {
        // jobs.mpJobs.forEach((singleMp) => {
        //   // singleMp['numberOfLearners'] = singleMp.mps.length
        // })
        newArray = jobs.jobs.concat(jobs.mpJobs)
      } else {
        newArray = jobs.jobs
      }

      // this.jobs = newArray;
      if (newArray.length == 0) {
        this.noJobsMsg = "No Jobs Added Yet!"
        this.displayNoJobMsg = true
      }
      else {
        console.log("total jobs display=======", newArray);

        let displayJobs = newArray
        let newJobArray = []
        displayJobs.forEach((singleJob) => {
          // console.log("single job value by client", singleJob);
          if (singleJob && singleJob.isArchive == false) {
            newJobArray.push(singleJob)
            this.jobs.push(singleJob);
          }
        })
        console.log("what is the length of this", newJobArray);

        if (newJobArray && newJobArray.length) {
          // this.jobs = newJobArray
          this.displayJobs(this.jobs)
          this.selectedJob = this.jobs[0]
        } else {
          console.log("this is final else part");

          this.noJobsMsg = "No Jobs Added Yet!"
          this.displayNoJobMsg = true
        }
        console.log("Jobs data training", this.jobs);
      }
      this.loading = false
    })
  }

}
